export default {"src":"/_next/static/media/videocall_40.534b7cdf.svg","height":40,"width":40,"blurWidth":0,"blurHeight":0};